import React,{useState,useEffect} from 'react'
import {Box, DataTable,Button } from 'grommet'
import { withRouter } from 'react-router-dom';
import { Add } from 'grommet-icons';
import { TableLoadLayer, NavigationSnackBar } from '../../../components/utils/shared/shared';
import { APIRequest } from '../../../components/utils/shared/requests';
import {ShipmentSuccessNotification} from '../../../components/utils/shared/shipmentViewFunctions'

function AllCustomers (props) {
  const [customers, setCustomers] = useState([]);
  const [load, setLoad] = useState(true)
  const [customerSucc,setCustomerSucc] = useState(props.location.customerSucc)
  useEffect(() => {     
    APIRequest('/customers').then(result => {setCustomers(result); setLoad(false)})
    setTimeout(() => {
      setCustomerSucc(undefined);
    }, 5000)
   },[]);
   
  return (
    <Box wrap flex="grow">
      <NavigationSnackBar title={'Customers'} user={props.user} pages={[{name: 'Dashboard', link:'/dashboard'}]}  />
      {customerSucc && (<ShipmentSuccessNotification label={"Customer"} edit={props.location.edit} />)}
    <Box direction='row' justify='end'>
        <Button primary label='Create Customer' margin='small' icon={<Add />} hoverIndicator onClick={() => props.history.push('/admin/customers/new')}/>
      </Box>
      <Box background={'background-front'} elevation='medium' round pad='small' margin='medium' overflow='scroll'>
        <DataTable  pad={'small'} size="medium"  margin='xsmall' background={{ header: { color: '#18445C'}, footer: { color: 'dark-3', opacity: 'strong' }}} columns={[ {header:"ID",property:"id",primary:true,sortable:true,search:false}, {header:"Name",property:"name", search:true}, {header:"Country",property:"address.Country.CountryName",sortable:true,search:false}, {header:"Lab",property:"lab.name",sortable:true,search:true}, ]} onClickRow={({datum}) => {props.history.push({pathname:`/admin/customers/edit/${datum.id}`})}} data={customers} />
        {load && (<TableLoadLayer load={load} label={"Loading Customers..."} />)}
       </Box>
   </Box>
  )
}

export default withRouter(AllCustomers)
